module.exports = __webpack_public_path__ + "img/Live-stage-logo.9d625ec9.jpg";